var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "basket-preview-wrapper h-100",
      class: {
        empty: !_vm.basketItems.length,
        "open-hover": _vm.hover,
        "open-right": !_vm.hover,
      },
    },
    [
      _c("div", { staticClass: "position-relative h-100" }, [
        _vm.showZubehoerIfExists === true && _vm.itemAdded == true
          ? _c(
              "div",
              {
                staticClass:
                  "basket-preview d-flex flex-column flex-nowrap bg-white shadow w-100",
                staticStyle: { "z-index": "99999" },
              },
              [
                _c(
                  "header",
                  {
                    staticClass:
                      "basket-preview-header border-bottom basket-preview-header-items",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-block",
                        attrs: { disabled: _vm.loading },
                        on: {
                          click: function ($event) {
                            return _vm.getItemsAndBuy()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$translate(
                                "StockShop::Template.previewCrossBtnNext"
                              )
                            ) +
                            "\n              "
                        ),
                        _vm.loading
                          ? [
                              _c("i", {
                                staticClass:
                                  "fa fa-spin fa-circle-o-notch ml-3",
                              }),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: {
                          type: "button",
                          "aria-label": _vm.$translate(
                            "Ceres::Template.closeIcon"
                          ),
                        },
                        on: {
                          click: function ($event) {
                            _vm.showZubehoerIfExists = false
                          },
                        },
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("×"),
                        ]),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "basket-preview-content flex-fill text-left" },
                  [
                    _c(
                      "div",
                      { staticClass: "p-3" },
                      [
                        _c("div", { staticClass: "h3 mb-5 mt-2" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "StockShop::Template.previewCrossHeader"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.previewItems.Accessory.length > 0
                          ? [
                              _c(
                                "div",
                                { staticClass: "h4 mt-2 font-weight-bold" },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$translate(
                                          "StockShop::Template.previewCrossAccessory"
                                        )
                                      ) +
                                      "\n                  "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _vm.previewItems.Accessory,
                                function (item) {
                                  return _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-check mt-3 mb-0 leftcheck",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: item.selected,
                                              expression: "item.selected",
                                            },
                                          ],
                                          staticClass: "form-check-input",
                                          attrs: {
                                            type: "checkbox",
                                            id: item.data.item.id,
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              item.selected
                                            )
                                              ? _vm._i(item.selected, null) > -1
                                              : item.selected,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a = item.selected,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      item,
                                                      "selected",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      item,
                                                      "selected",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(item, "selected", $$c)
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "form-check-label",
                                            attrs: { for: item.data.item.id },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "d-flex" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "d-flex mr-3",
                                                    staticStyle: {
                                                      height: "50px",
                                                      width: "50px",
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticStyle: {
                                                        "object-fit": "cover",
                                                        "max-width": "100%",
                                                      },
                                                      attrs: {
                                                        src: item.data.images
                                                          .all[0].urlMiddle,
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "white-space": "nowrap",
                                                        overflow: "hidden",
                                                        "text-overflow":
                                                          "ellipsis",
                                                        width: "290px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.data.texts.name1
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "font-weight-bold",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.data.prices
                                                            .default.price
                                                            .formatted
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ])
                                }
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "p-3 border-top" }, [
                  _c("div", { staticClass: "basket-preview-footer" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-5" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-primary btn-block",
                            on: {
                              click: function ($event) {
                                _vm.showZubehoerIfExists = false
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$translate(
                                    "StockShop::Template.previewCrossBtnShop"
                                  )
                                ) +
                                "\n                  "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-7" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-block",
                            attrs: { disabled: _vm.loading },
                            on: {
                              click: function ($event) {
                                return _vm.getItemsAndBuy()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$translate(
                                    "StockShop::Template.previewCrossBtnNext"
                                  )
                                ) +
                                "\n                    "
                            ),
                            _vm.loading
                              ? [
                                  _c("i", {
                                    staticClass:
                                      "fa fa-spin fa-circle-o-notch ml-3",
                                  }),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "basket-preview d-flex flex-column flex-nowrap bg-white shadow w-100",
          },
          [
            _c(
              "header",
              { staticClass: "basket-preview-header border-bottom p-3" },
              [
                _c("span", { staticClass: "h3 mb-0" }, [
                  _vm._v(
                    _vm._s(_vm.$translate("Ceres::Template.basketPreview"))
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "toggle-basket-preview",
                        rawName: "v-toggle-basket-preview",
                      },
                    ],
                    staticClass: "close",
                    attrs: { type: "button", "aria-label": "Close" },
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×"),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _vm.basketNotifications.length > 0
              ? _c(
                  "div",
                  _vm._l(_vm.basketNotifications, function (notification) {
                    return _c(
                      "div",
                      {
                        key: notification.id,
                        staticClass: "w-100 alert alert-danger",
                      },
                      [_c("div", [_vm._v(_vm._s(notification.message))])]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "basket-preview-content d-flex flex-fill" },
              [
                _c("basket-list", {
                  staticClass:
                    "item-list d-flex flex-fill flex-nowrap flex-column overflow-auto px-3",
                  attrs: { "is-preview": true },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "before-basket-item",
                        fn: function () {
                          return [_vm._t("before-basket-item")]
                        },
                        proxy: true,
                      },
                      {
                        key: "after-basket-item",
                        fn: function () {
                          return [_vm._t("after-basket-item")]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "totals d-flex flex-nowrap flex-column px-3 pt-3",
                  },
                  [
                    _vm.showShippingCountrySelect
                      ? _c("shipping-country-select", {
                          attrs: {
                            "basket-select": true,
                            "open-basket-preview": true,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _vm._t("before-basket-totals"),
                    _vm._v(" "),
                    _c("basket-totals", {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "before-item-sum",
                            fn: function () {
                              return [_vm._t("before-item-sum")]
                            },
                            proxy: true,
                          },
                          {
                            key: "after-item-sum",
                            fn: function () {
                              return [_vm._t("after-item-sum")]
                            },
                            proxy: true,
                          },
                          {
                            key: "before-shipping-costs",
                            fn: function () {
                              return [_vm._t("before-shipping-costs")]
                            },
                            proxy: true,
                          },
                          {
                            key: "after-shipping-costs",
                            fn: function () {
                              return [_vm._t("after-shipping-costs")]
                            },
                            proxy: true,
                          },
                          {
                            key: "before-total-sum",
                            fn: function () {
                              return [_vm._t("before-total-sum")]
                            },
                            proxy: true,
                          },
                          {
                            key: "before-vat",
                            fn: function () {
                              return [_vm._t("before-vat")]
                            },
                            proxy: true,
                          },
                          {
                            key: "after-vat",
                            fn: function () {
                              return [_vm._t("after-vat")]
                            },
                            proxy: true,
                          },
                          {
                            key: "after-total-sum",
                            fn: function () {
                              return [_vm._t("after-total-sum")]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _vm._v(" "),
                    _vm._t("after-basket-totals"),
                    _vm._v(" "),
                    _vm.mbw.amountReached
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "basket-preview-footer d-flex pb-3",
                            },
                            [
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "waiting-animation-infinite",
                                      rawName: "v-waiting-animation-infinite",
                                    },
                                  ],
                                  staticClass:
                                    "btn btn-outline-primary btn-block",
                                  attrs: {
                                    href: _vm.$ceres.urls.basket,
                                    rel: "nofollow",
                                    title: _vm.$translate(
                                      "Ceres::Template.basket"
                                    ),
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-shopping-cart",
                                  }),
                                  _vm._v(
                                    "\n                              " +
                                      _vm._s(
                                        _vm.$translate("Ceres::Template.basket")
                                      ) +
                                      "\n                          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._t("before-checkout-button"),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "waiting-animation-infinite",
                                      rawName: "v-waiting-animation-infinite",
                                    },
                                  ],
                                  staticClass: "btn btn-primary btn-block",
                                  attrs: {
                                    href: _vm.$ceres.urls.checkout,
                                    rel: "nofollow",
                                    title: _vm.$translate(
                                      "Ceres::Template.basketCheckout"
                                    ),
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-arrow-right",
                                    attrs: { "aria-hidden": "true" },
                                  }),
                                  _vm._v(
                                    "\n                              " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.basketCheckout"
                                        )
                                      ) +
                                      "\n                          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._t("after-checkout-button"),
                            ],
                            2
                          ),
                        ]
                      : [
                          _c("p", {
                            staticClass: "text-center my-2 pt-3 border-top",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$translate(
                                  "StockShop::Template.minOrderValue"
                                )
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "progress" }, [
                            _c("div", {
                              staticClass: "progress-bar",
                              style: "width:" + _vm.mbw.percentageReached + "%",
                              attrs: {
                                role: "progressbar",
                                "aria-valuenow": "0",
                                "aria-valuemin": "0",
                                "aria-valuemax": _vm.mbw.percentageReached,
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "text-center my-2" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$translate(
                                    "StockShop::Template.minOrderValueToGet"
                                  )
                                ) +
                                "\n                        " +
                                _vm._s(
                                  _vm._f("currency")(_vm.mbw.restToReach)
                                ) +
                                "\n                        " +
                                _vm._s(
                                  _vm.$translate(
                                    "StockShop::Template.minOrderValueToGet2"
                                  )
                                ) +
                                "\n                      "
                            ),
                          ]),
                        ],
                  ],
                  2
                ),
              ],
              1
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", {
        directives: [
          { name: "toggle-basket-preview", rawName: "v-toggle-basket-preview" },
        ],
        staticClass: "basket-preview-overlay",
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }